<template>
    <table id="productAndMallTable" v-if="!reloaded">
        <thead>
            <tr>
                <th class="fixedTateYoko" rowspan="3" v-if="dateUnit === 'day'">日付</th>
                <th class="fixedTateYoko" rowspan="3" v-if="dateUnit === 'week'">週</th>
                <th class="fixedTateYoko" rowspan="3" v-if="dateUnit === 'month'">年月</th>
                <template v-if="periodType === 'mall-event-day'">
                    <th class="fixedYoko" rowspan="3">イベント名</th>
                </template>
                <th class="fixedYoko" :colspan="this.roasCostCol" rowspan="2">ROAS</th>
                <th class="fixedYoko" colspan="4" rowspan="2">売上（税抜）</th>
                <th class="fixedYoko" colspan="4" rowspan="2">数量</th>
                <th class="fixedYoko" colspan="3" rowspan="2">広告費</th>
                <template v-if="showCosts">
                    <!-- 閉じているとき -->
                    <th v-show="!show" class="fixedYoko" colspan="2" rowspan="2">費用</th>
                    <!-- 開いているとき -->
                    <th v-show="show" class="fixedYoko" colspan="7" rowspan="2">費用</th>
                    <th v-on:click="summaryCostToggle" class="summaryCostToggle" rowspan="3"><span
                            v-bind:class="[open ? 'openToggle' : '']">▼</span></th>
                </template>
                <!-- 各広告媒体の広告費のcolspan可変にする -->
                <th class="fixedYoko" :colspan="this.adCostCol">各広告媒体の広告費</th>
            </tr>
            <tr>
                <!-- 自社のcolspan可変にする -->
                <th class="fixedYokoTwo" :colspan="this.otherMediaCol" width="12%">自社</th>
                <template v-if="!deploymented">
                    <th class="fixedYokoTwo" :colspan="this.adCostCol - this.otherMediaCol" width="48%">モール</th>
                </template>
                <template v-else>
                    <template v-for="mallService in services.malls">
                        <template v-for="service in mallService.services">
                            <th class="fixedYokoTwo" :key="service.id"
                                :colspan="serviceReports[service.service_id] ? Object.keys(serviceReports[service.service_id]).length : 1">
                                モール（{{ service.name }}）
                                <template
                                    v-if="serviceReports[service.service_id] && Object.keys(serviceReports[service.service_id]).length > 0">
                                    <span class="shrinkBtn" @click="deploymentedDisp"></span></template>
                            </th>
                        </template>
                    </template>
                </template>

            </tr>
            <tr>
                <!-- ROAS -->
                <th class="fixedYokoTwo fixedYokoThree">
                    全体ROAS<span class="shrinkBtn" @click="roasDisp"></span>
                </th>
                <template v-if="roasTab">
                    <th class="fixedYokoTwo fixedYokoThree">EC ROAS</th>
                </template>
                <th class="fixedYokoTwo fixedYokoThree">自社</th>
                <th class="fixedYokoTwo fixedYokoThree">モール</th>

                <!-- 売上 -->
                <th class="fixedYokoTwo fixedYokoThree">合計</th>
                <th class="fixedYokoTwo fixedYokoThree">自社</th>
                <th class="fixedYokoTwo fixedYokoThree">モール</th>
                <th class="fixedYokoTwo fixedYokoThree">店舗</th>

                <!-- 数量 -->
                <th class="fixedYokoTwo fixedYokoThree">合計</th>
                <th class="fixedYokoTwo fixedYokoThree">自社</th>
                <th class="fixedYokoTwo fixedYokoThree">モール</th>
                <th class="fixedYokoTwo fixedYokoThree">店舗</th>

                <!-- 広告費 -->
                <th class="fixedYokoTwo fixedYokoThree">合計</th>
                <th class="fixedYokoTwo fixedYokoThree">自社</th>
                <th class="fixedYokoTwo fixedYokoThree">モール</th>

                <!-- 費用 -->
                <template v-if="showCosts">
                    <th v-show="!show" class="fixedYokoTwo fixedYokoThree">費用合計</th>
                    <th v-show="!show" class="fixedYokoTwo fixedYokoThree">粗利</th>
                    <!-- 開いているとき -->
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">原価</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">送料</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">手数料</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">ポイント</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">費用合計</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">粗利</th>
                    <th v-show="show" class="fixedYokoTwo fixedYokoThree">粗利率</th>
                </template>

                <!-- 各広告媒体の広告費 -->
                <!-- 自社（レギュラー） -->
                <th class="fixedYokoTwo fixedYokoThree">Facebook</th>
                <th class="fixedYokoTwo fixedYokoThree">Yahoo</th>
                <th class="fixedYokoTwo fixedYokoThree">Google</th>
                <th class="fixedYokoTwo fixedYokoThree">Line</th>
                <th class="fixedYokoTwo fixedYokoThree">Criteo</th>
                <th class="fixedYokoTwo fixedYokoThree">Microsoft</th>

                <!-- 自社（その他） -->
                <template
                    v-for="(cost, medium) in performanceReports.outputs[Object.keys(performanceReports.outputs)[0]]['costsOfMedia']['privateSite']['otherMedia']">
                    <th class="fixedYokoTwo fixedYokoThree" :key="medium">
                        <span class="otherMedium">
                            {{ medium }}
                        </span>
                    </th>
                </template>

                <!-- モール -->
                <template v-for="mallService in services.malls">
                    <template v-for="service in mallService.services">
                        <template v-if="!deploymented">
                            <th class="fixedYokoTwo fixedYokoThree" :key="service.id">
                                {{ mallService.name }}<br>({{ service.name }})
                                <template
                                    v-if="serviceReports[service.service_id] && Object.keys(serviceReports[service.service_id]).length > 0">
                                    <span class="shrinkBtn" @click="deploymentedDisp"></span>
                                </template>
                            </th>
                        </template>
                        <template v-else>
                            <template
                                v-if="serviceReports[service.service_id] && Object.keys(serviceReports[service.service_id]).length > 0">
                                <template v-for="s in serviceReports[service.service_id]">
                                    <th class="fixedYokoTwo fixedYokoThree" :key="s.id" v-html="wrapName(s.name)"></th>
                                </template>
                            </template>
                            <template v-else>
                                <th class="fixedYokoTwo fixedYokoThree" :key="service.id">合計</th>
                            </template>
                        </template>
                    </template>
                </template>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(output, monthOrDay, index) in dispReports" class="selectRoasRow" :key="index">
                <!-- 日付 -->
                <td class="fixedTate dayField" :class="dayFieldColorClass(monthOrDay)">{{ monthOrDay }}</td>

                <!-- イベント名 -->
                <template v-if="periodType === 'mall-event-day'">
                    <td class="event_name">{{ output["event"]["name"] }}</td>
                </template>

                <template>
                    <!-- ROAS(合計･自社･モール) -->
                    <td>{{ maskRowRoas(monthOrDay, output["roas"]["totalRoas"]) | percentDisp }}</td>
                    <td v-if="roasTab">{{ maskRowRoas(monthOrDay, output["roas"]["totalEcRoas"]) | percentDisp }}</td>
                    <td>{{ maskRowRoas(monthOrDay, output["roas"]["privateRoas"]) | percentDisp }}</td>
                    <td>{{ maskRowRoas(monthOrDay, output["roas"]["mallRoas"]) | percentDisp }}</td>

                    <!-- 売上(合計･自社･モール・店舗) -->
                    <td>{{ output["earnings"]["totalEarnings"] | priceLocaleString }}</td>
                    <td>{{ output["earnings"]["privateEarnings"] | priceLocaleString }}</td>
                    <td>{{ output["earnings"]["mallEarnings"] | priceLocaleString }}</td>
                    <td>{{ output["earnings"]["shopEarnings"] | priceLocaleString }}</td>

                    <!-- 数量(合計･自社･モール・店舗) -->
                    <td>{{ output["quantity"]["totalQuantity"] }}</td>
                    <td>{{ output["quantity"]["privateQuantity"] }}</td>
                    <td>{{ output["quantity"]["mallQuantity"] }}</td>
                    <td>{{ output["quantity"]["shopQuantity"] }}</td>

                    <!-- 広告費(合計･自社･モール) -->
                    <td>{{ output["costs"]["totalCosts"] | priceLocaleString }}</td>
                    <td>{{ output["costs"]["privateCosts"] | priceLocaleString }}</td>
                    <td>{{ output["costs"]["mallCosts"] | priceLocaleString }}</td>

                    <!-- 原価・送料・手数料・費用総額 -->
                    <template v-if="showCosts">
                        <!-- 閉じているとき -->
                        <td v-show="!show">{{ output["costs"]["all"] | priceLocaleString }}</td>
                        <td v-show="!show">{{ output["margins"]["margin"] | priceLocaleString }}</td>
                        <!-- 開いているとき -->
                        <td v-show="show">{{ output["costs"]["productCosts"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["costs"]["deliveryCosts"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["costs"]["chargeCosts"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["costs"]["mallPoints"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["costs"]["all"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["margins"]["margin"] | priceLocaleString }}</td>
                        <td v-show="show">{{ output["margins"]["rate"] | percentDisp }}</td>
                        <td v-on:click="summaryCostToggle" class="toggleSpacer"></td>
                    </template>
                    <!-- 各広告媒体の広告費(自社（facebook・yahoo・google・line・criteo・Microsoft）) -->
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["facebook"] | priceLocaleString }}</td>
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["yahoo"] | priceLocaleString }}</td>
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["google"] | priceLocaleString }}</td>
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["line"] | priceLocaleString }}</td>
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["criteo"] | priceLocaleString }}</td>
                    <td>{{ output["costsOfMedia"]['privateSite']['regularMedia']["Microsoft"] | priceLocaleString }}
                    </td>

                    <!-- 各広告媒体の広告費(自社（その他の広告媒体）) -->
                    <td v-for="(cost, medium, index) in output['costsOfMedia']['privateSite']['otherMedia']"
                        :key="index">
                        {{ cost.totalPrivateSiteCosts | priceLocaleString }}
                    </td>

                    <!-- 各広告媒体の広告費(ECモール) -->
                    <template v-for="mallService in services.malls">
                        <template v-for="service in mallService.services">
                            <template v-if="!deploymented">
                                <td :key="service.id">
                                    <span>{{ output['costsOfMedia']['mallSite'][service.id] | priceLocaleString
                                        }}</span>
                                </td>
                            </template>
                            <template v-else>
                                <template
                                    v-if="serviceReports[service.service_id] && Object.keys(serviceReports[service.service_id]).length > 0">
                                    <template v-for="s, index in serviceReports[service.service_id]">
                                        <td :key="service.id + '-' + s.id + '-' + index">{{
                                            s.reports[monthOrDay]["cost"] | priceLocaleString }}</td>
                                    </template>
                                </template>
                                <template v-else>
                                    <td :key="service.id">
                                        <span>{{ output['costsOfMedia']['mallSite'][service.id] | priceLocaleString
                                            }}</span>
                                    </td>
                                </template>

                            </template>
                        </template>
                    </template>
                </template>
            </tr>
        </tbody>
        <tfoot>
            <tr class="selectRoasRow total">
                <template>
                    <!-- 日付 -->
                    <td class="fixedTate dayField">合計</td>

                    <!-- イベント名 -->
                    <template v-if="periodType === 'mall-event-day'">
                        <td v-on:click="summaryCostToggle" class="toggleSpacer"></td>
                    </template>

                    <!-- ROAS(合計･自社･モール) -->
                    <td>{{ maskTotalRoas(performanceReports['totalReports']["roas"]["totalRoas"]) | percentDisp }}</td>
                    <td v-if="roasTab">{{ maskTotalRoas(performanceReports['totalReports']["roas"]["totalEcRoas"]) | percentDisp }}
                    </td>
                    <td>{{ maskTotalRoas(performanceReports['totalReports']["roas"]["privateRoas"]) | percentDisp }}</td>
                    <td>{{ maskTotalRoas(performanceReports['totalReports']["roas"]["mallRoas"]) | percentDisp }}</td>

                    <!-- 売上(合計･自社･モール・店舗) -->
                    <td>{{ performanceReports['totalReports']["earnings"]["totalEarnings"] | priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["earnings"]["privateEarnings"] | priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["earnings"]["mallEarnings"] | priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["earnings"]["shopEarnings"] | priceLocaleString }}</td>

                    <!-- 数量(合計･自社･モール・店舗) -->
                    <td>{{ performanceReports['totalReports']["quantity"]["totalQuantity"] }}</td>
                    <td>{{ performanceReports['totalReports']["quantity"]["privateQuantity"] }}</td>
                    <td>{{ performanceReports['totalReports']["quantity"]["mallQuantity"] }}</td>
                    <td>{{ performanceReports['totalReports']["quantity"]["shopQuantity"] }}</td>

                    <!-- 広告費(合計･自社･モール) -->
                    <td>{{ performanceReports['totalReports']["costs"]["totalCosts"] | priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costs"]["privateCosts"] | priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costs"]["mallCosts"] | priceLocaleString }}</td>

                    <!-- 原価・送料・手数料・費用総額 -->
                    <template v-if="showCosts">
                        <!-- 閉じているとき -->
                        <td v-show="!show">{{ performanceReports['totalReports']["costs"]["all"] | priceLocaleString }}
                        </td>
                        <td v-show="!show">{{ performanceReports['totalReports']["margins"]["margin"] |
                            priceLocaleString }}
                        </td>
                        <!-- 開いているとき -->
                        <td v-show="show">{{ performanceReports['totalReports']["costs"]["productCosts"] |
                            priceLocaleString }}</td>
                        <td v-show="show">{{ performanceReports['totalReports']["costs"]["deliveryCosts"] |
                            priceLocaleString }}</td>
                        <td v-show="show">{{ performanceReports['totalReports']["costs"]["chargeCosts"] |
                            priceLocaleString }}
                        </td>
                        <td v-show="show">{{ performanceReports['totalReports']["costs"]["mallPoints"] |
                            priceLocaleString }}</td>
                        <td v-show="show">{{ performanceReports['totalReports']["costs"]["all"] | priceLocaleString }}
                        </td>
                        <td v-show="show">{{ performanceReports['totalReports']["margins"]["margin"] | priceLocaleString
                            }}
                        </td>
                        <td v-show="show">{{ performanceReports['totalReports']["margins"]["rate"] | percentDisp }}</td>
                        <td v-on:click="summaryCostToggle" class="toggleSpacer"></td>
                    </template>
                    <!-- 各広告媒体の広告費(自社（facebook・yahoo・google・line・criteo・microsoft）) -->
                    <td>{{ performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["facebook"]
                        |
                        priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["yahoo"] |
                        priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["google"] |
                        priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["line"] |
                        priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["criteo"] |
                        priceLocaleString }}</td>
                    <td>{{
                        performanceReports['totalReports']["costsOfMedia"]['privateSite']['regularMedia']["Microsoft"] |
                        priceLocaleString }}</td>
                    <!-- 各広告媒体の広告費(自社（その他の広告媒体）) -->
                    <td v-for="(cost, medium, index) in performanceReports['totalReports']['costsOfMedia']['privateSite']['otherMedia']"
                        :key="index">
                        {{ cost.totalPrivateSiteCosts | priceLocaleString }}
                    </td>
                    <!-- 各広告媒体の広告費(ECモール) -->
                    <template v-for="mallService in services.malls">
                        <template v-for="service in mallService.services">
                            <template v-if="!deploymented">
                                <td :key="service.id">
                                    {{ performanceReports['totalReports']['costsOfMedia']['mallSite'][service.id] |
                                        priceLocaleString }}
                                </td>
                            </template>
                            <template v-else>
                                <template
                                    v-if="serviceReports[service.service_id] && Object.keys(serviceReports[service.service_id]).length > 0">
                                    <template v-for="s, index in serviceReports[service.service_id]">
                                        <td :key="service.id + '-' + s.id + '-' + index">{{ s["sum"] | priceLocaleString
                                            }}</td>
                                    </template>
                                </template>
                                <template v-else>
                                    <td :key="service.id">
                                        {{ performanceReports['totalReports']['costsOfMedia']['mallSite'][service.id] |
                                            priceLocaleString }}
                                    </td>
                                </template>
                            </template>
                        </template>
                    </template>
                </template>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ProductMallTable',
    data() {
        return {
            reloaded: false,
            show: false,
            open: false,
            adCostColInitial: 17, //各広告媒体の広告費のタイトル部分のcolspan初期値（自社（その他）以外の数）
            otherMediaColInitial: 6, //各広告媒体の広告費 自社（レギュラー）分のタイトル部分のcolspan初期値（自社（レギュラー）の数）
            adCostCol: 0,  //各広告媒体の広告費のタイトル部分のcolspan設定値
            otherMediaCol: 0, //各広告媒体の広告費 自社分のタイトル部分のcolspan設定値
            roasCostCol: 3, //ROASタイトル部分のcolspan設定値
            serviceToggle: [],
            deploymented: false,
            roasTab: false, //「EC ROAS」表示切替タブ
        }
    },
    props: {
        isOrderAsc: Boolean,
        isMonthly: Boolean,
        performanceReports: Object,
        serviceReports: Object,
        showCosts: Boolean,
        dateUnit: String,
        periodType: String,
        roasHiddenFrom: String, // この日以降の ROAS を「-」にする（Home の夜〜翌朝5時のみ）
    },
    mounted: function () {
        //Home.vueで「performanceReports」がセットされるタイミングが遅いためif分でエラーが出るの回避
        //RoasProduct.vueでは「performanceReports」がセットされている状態なのでmountedでタイトル部分のcolspan調整する
        if (this.performanceReports.outputs !== null && this.performanceReports.outputs !== undefined) {
            //自社広告費のうち「その他の広告媒体」の数を取得
            const obj = this.performanceReports.outputs[Object.keys(this.performanceReports.outputs)[0]]['costsOfMedia']['privateSite']['otherMedia'];
            const count = Object.keys(obj).length;

            //タイトル部分のcolspan
            //固定の広告媒体数 + その他の広告媒体数
            this.adCostCol = this.adCostColInitial + count;
            this.otherMediaCol = this.otherMediaColInitial + count;
        }

        this.$nextTick(() => {
            this.updateThirdRowTop();
        });
    },
    methods: {
        // 広告費がまだ入っていない日（roasHiddenFrom 以降）の ROAS を「-」にする
        // 当日分の売上は夜の集計で入るが、広告費は翌朝4時の取込で入るため、そのままだと極端な値になる
        maskRowRoas(key, value) {
            return this.isRoasHiddenRow(key) ? '-' : value;
        },
        // 合計行は、広告費の無い日を期間に含むと高めに出るため「-」にする
        maskTotalRoas(value) {
            return this.roasHiddenFrom ? '-' : value;
        },
        isRoasHiddenRow(key) {
            if (!this.roasHiddenFrom) {
                return false;
            }
            if (this.dateUnit === 'day') {
                return key >= this.roasHiddenFrom;
            }
            // 週・月の単位では、広告費の無い日（期間の最終日）を含む最後の行
            const keys = Object.keys(this.performanceReports.outputs || {});
            return String(key) === keys[keys.length - 1];
        },
        // rowTransitionDelayStyle(index) {
        //     const delay = Math.round((500 / (this.recodLength + 1)) * index);
        //     // CSS変数 css側で処理
        //     return {'--transition-delay': `${delay}ms`};
        // },
        rowClosingMonthStartDateClass(date) {
            if (!date.match(this.reportStatus.isMonthlyGrouped ? /^\d+-12/ : /^\d+-12-01/)) {
                return;
            }
            return {
                closingMonthStartDateRow: true,
                isOrderAsc: this.isOrderAsc,
            };
        },
        dayFieldColorClass(date) {
            if (this.isMonthly) {
                return;
            }

            if (this.holidaysFind(date)) {
                return 'isHoliday';
            }
            // day: (Sunday as 0, Saturday as 6)
            const week = this.$dayjs(date).get('day');

            if (week == 0) {
                return 'isSunday';
            } else if (week == 6) {
                return 'isSaturday';
            } else {
                return null;
            }
        },
        //費用欄の折り畳み制御
        summaryCostToggle() {
            this.show = !this.show;
            this.open = !this.open;
        },
        roasDisp() {
            if (this.roasTab) {
                this.roasTab = false;
                this.roasCostCol = 3;
            }
            else {
                this.roasTab = true;
                this.roasCostCol = 4;
            }
        },
        deploymentedDisp() {
            if (this.deploymented) {
                // 表を展開させた時
                this.deploymented = false
            } else {
                // 表を展開させなかった時
                this.deploymented = true
            }
            this.$nextTick(() => {
                this.updateThirdRowTop();
            });
        },
        updateThirdRowTop() {
            const table = document.getElementById('productAndMallTable');
            if (!table) return;
            const rows = table.querySelector('thead').rows;
            if (rows.length < 3) return;
            const row1Height = rows[0].offsetHeight;
            const row2Height = rows[1].offsetHeight;
            table.style.setProperty('--thead-row3-top', (row1Height + row2Height) + 'px');
        },
        wrapName(name) {
            var result = name;
            if (name.length > 10) {
                result = name.substring(0, 6) + "<br/>" + name.substring(6);
            }
            return result;
        }
    },
    watch: {
        //Home.vueで「performanceReports」がセットされるタイミングが遅いため、
        //watchで監視してタイトル部分のcolspan調整する
        performanceReports: function (newVal) {
            //自社広告費のうち「その他の広告媒体」の数を取得
            const obj = newVal.outputs[Object.keys(this.performanceReports.outputs)[0]]['costsOfMedia']['privateSite']['otherMedia'];
            const count = Object.keys(obj).length;

            //タイトル部分のcolspan
            //固定の広告媒体数 + その他の広告媒体数
            this.adCostCol = this.adCostColInitial + count;
            this.otherMediaCol = this.otherMediaColInitial + count;
        }
    },
    computed: {
        dispReports: function () {
            if (this.isOrderAsc) {
                return this.performanceReports.outputs
            } else {
                const outputs = Object.entries(this.performanceReports.outputs).slice().reverse();
                return Object.fromEntries(outputs);
            }
        },
        ...mapGetters({
            services: 'services/allByGroup',
            holidaysFind: 'holidays/find',
        }),
    },
}
</script>

<style scoped lang="sass">
#productAndMallTable
    border-collapse: separate
    margin: 0px auto
    white-space: nowrap
    th
        background: $grayColor
        border: 1px solid #bbb
        color: $whiteColor
        padding: 10px 5px
        text-align: left
        top: 0
        vertical-align: middle
        .otherMedium
            border-bottom: double
    tbody
        tr
            background: $whiteColor
        tr:nth-child(odd)
            background: #eee
        td.event_name
            text-align: left
        td
            .temp_min
                color: blue
            .temp_high
                color: red
    tfoot
        tr
            position: sticky
            bottom: 0
            z-index: 3
            background: $whiteColor
    tr, tr:nth-child(odd)
        &:hover
            background-color: #c8f0e8
    .summaryCostToggle
        position: sticky
        top: 0
        z-index: 1
        padding: 0 9px
        background: linear-gradient(90deg, rgb(220, 220, 220) 0%, rgb(255, 255, 255) 50%)
        border-top: none
        border-bottom: none
        border-left: none
        color: #333
        cursor: pointer
        transition: .3s
        span
            position: absolute
            left: 3px
            top: 128px
            z-index: 1
            display: block
            color: $mainColor
            transform: rotate(-90deg);
            transition: .2s
            &.openToggle
                transform: translateX(-2px) rotate(90deg);
                transition: .2s
    .toggleSpacer
        background: linear-gradient(90deg, rgb(220, 220, 220) 0%, rgb(255, 255, 255) 50%)
        border: none !important
        cursor: pointer
.fixedTate
    background: inherit
    left: 0
    position: sticky
    z-index: 1
.fixedYoko
    background: inherit
    position: sticky
    top: 0
    z-index: 1
.fixedYokoTwo
    background: $whiteColor
    position: sticky
    top: 36px !important
    transition: all .2s ease-in-out
    z-index: 1
.fixedYokoTwo_s
    top: 37px !important
.fixedYokoThree
    top: var(--thead-row3-top, 72px) !important
.fixedTateYoko
    left: 0
    position: sticky
    top: 0
    z-index: 2
.selectRoasRow
    color: $grayColor
    position: relative
    td
        border: 1px solid #bbb
        padding: 5px
        text-align: right
    .dayField
        text-align: left
        &.isHoliday, &.isSunday
            color: #f55
        &.isSaturday
            color: #55f
    .editCell
        cursor: pointer
        padding: 0
        position: relative
    .editCellText
        border: 1px solid $mainColor
        padding: 5px
        width: 100%
    &.closingMonthStartDateRow:not(.isOrderAsc) td
        border-bottom: 1px solid $mainColor
    &.closingMonthStartDateRow.isOrderAsc td
        border-top: 1px solid $mainColor
    &.total
        td
            border-top: 2px solid $grayColor
        .dayField
            text-align: center
.selectRoasRowTransition-enter
    transform: translateX(100px)
    opacity: 0
.selectRoasRowTransition-enter-active
    transition: all 500ms linear var(--transition-delay)
.shrinkBtn
    background: #444
    border: 1px solid #fff
    cursor: pointer
    display: block
    float: right
    height: 15px
    margin-right: 10px
    overflow: hidden
    position: relative
    width: 30px
    &::before
        background: #00ad90
        content: ''
        height: 13px
        position: absolute
        right: 0
        top: 0
        transform: translateX(75%)
        transition: all .3s ease-in-out
        width: 30px
    &::after
        border-bottom: 1px solid #fff
        border-right: 1px solid #fff
        content: ''
        display: block
        height: 5px
        position: absolute
        right: 12px
        top: 50%
        transform: rotate(135deg) translateY(-50%)
        transition: all .4s ease-in-out
        transform-origin: 50% 0
        width: 5px
    &:hover
        &::before
            transform: translateX(0%)

@include sp()
    #productAndMallTable
        font-size: 12px
        .fixedYokoThree
            top: 68px !important
        thead
            tr:nth-child(2)
                .fixedYokoTwo
                    top: 34px !important
            th
                &.summaryCostToggle
                    position: sticky
                    z-index: 1
</style>
